// src/blogs/EdgeNavZones.jsx
// Thin click strips along the far left/right edges of the screen: next/previous
// post within the current blog's feed. The right strip sits beneath the filter
// sidebar's tab/panel and is disabled while the sidebar is open, so it never
// fights that edge's own UI for clicks.
import React from "react";

export default function EdgeNavZones({ onPrev, onNext, rightDisabled = false }) {
  return (
    <>
      <button
        type="button"
        className="edge-nav-zone edge-nav-zone--left"
        aria-label="Previous post"
        onClick={onPrev}
      />
      <button
        type="button"
        className="edge-nav-zone edge-nav-zone--right"
        aria-label="Next post"
        onClick={onNext}
        disabled={rightDisabled}
      />
    </>
  );
}
